export default __webpack_public_path__ + "static/media/kanryou-form.9649be10.png";